import { gql } from "apollo-boost"

export const UPDATE_INDICATORS_ORDER_INDEX = gql`
  mutation IndicatorResolver ($data: [UpdateIndicatorOrderIndexInput!]!) {
    UpdateIndicatorsOrderIndex(data: $data)
  }
`